export const getBorderCortegeFromValue = (style = '') => {
  const arr = style && style.split(' ');
  let result = [];
  result.push(arr[0] ? arr[0] : '0px');
  result.push(arr[1] ? arr[1] : 'solid');
  result.push(arr[2] ? arr[2] : '#000000');
  return  result;
}
